import {
  FilterMode,
  AiSearchConversation_OrderBy,
  AiSearchConversation,
  SortOrder,
  AiSearchConversation_Filter,
} from "../../../api/graphql";
import { getApiInstance } from "../../../api";
import { nullToUndefinedRecursive } from "../../../common/utils";

export const aiSearchConversationService = {
  createOne: () => (): Promise<string> => new Promise(() => ""),
  getOne: async (id: string, accessToken: string, activityStore: any) => {
    const api = getApiInstance(accessToken, activityStore);
    const result = await api.aiSearchConversationOne({ id });
    return result.aiSearchConversationOne as AiSearchConversation;
  },
  getFilteredList: async (
    accessToken: string,
    offset: number,
    take: number,
    searchValue: string,
    _language: string = "es",
    orderBy: AiSearchConversation_OrderBy[] | null = null,
    filter: AiSearchConversation_Filter | null = null,
    activityStore: any
  ) => {
    const api = getApiInstance(accessToken, activityStore);

    let where: AiSearchConversation_Filter | undefined;
    if (searchValue !== "") {
      where = { id: { contains: searchValue, mode: FilterMode.Insensitive } };
    }

    if (filter) {
      if (where) {
        where = { AND: [filter, where] };
      } else {
        where = filter;
      }
    }

    const result = await api.aiSearchConversationListWithOffset({
      offset,
      take,
      orderBy: orderBy ? orderBy : { id: SortOrder.Asc },
      where,
    });
    const list = nullToUndefinedRecursive(
      result.aiSearchConversationListWithOffset
    ) as AiSearchConversation[];
    return { list, orderBy };
  },
};
